// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"334":"app-theme-dark1","522":"app-theme-dark0","554":"app-theme-light1","641":"app-theme-light0"}[chunkId] || chunkId) + "." + {"334":"217f5888","522":"9f9e9fdb","554":"5898a4fb","641":"3596a128","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};